import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "HelpCenter",
  "use": "HelpCenter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"HelpCenter\"><path d=\"M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 2c-4.415 0-8 3.585-8 8s3.585 8 8 8 8-3.585 8-8-3.585-8-8-8zm0 11a1 1 0 110 2 1 1 0 010-2zm0-9a3 3 0 011.6 5.538l-.16.094a1.404 1.404 0 00-.383.289.404.404 0 00-.05.069l-.007.016V13.5a1 1 0 01-1.993.117L11 13.5V12c0-.58.253-1.047.539-1.38.281-.33.63-.572.94-.742a1 1 0 10-1.472-.995L11 9a1 1 0 11-2 0 3 3 0 013-3z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol